@if (pendingPsychologists().length > 0) {
  <div class="approve-container">
    <div class="title">{{ 'approve_psychologist.title' | translate }}</div>
    @for (psychologist of pendingPsychologists(); track psychologist.id) {
      <div class="pending-row">
        <div class="info">
          <span class="name">{{psychologist.first_name + ' ' + psychologist.last_name}}</span>
          <span>
            {{ 'approve_psychologist.license' | translate }}
            {{
              psychologist.council_number 
              + ' - ' 
              + (getCountryLabel(psychologist.council_country || '') | translate)
            }}
          </span>
          <span>
            {{ 'approve_psychologist.languages' | translate }}
            {{getLanguageLabel(psychologist?.session_languages || [''])}}
          </span>
          <span>
            {{ 'approve_psychologist.service' | translate }}
            {{psychologist.service_description}}
          </span>
        </div>
        <div class="actions">
          @if (loading()) {
            <span class="loader"></span>
          } @else {
            <mat-icon matRipple class="reject" (click)="reject(psychologist)">thumb_down</mat-icon>
            <mat-icon matRipple class="accept" (click)="approve(psychologist)">thumb_up</mat-icon>
          }
        </div>      
      </div>
    }
  </div>
}
